import { useEffect, useState } from "react";
import { Dialog, DialogContent, Fade, useMediaQuery } from "@mui/material";
import { LuTriangleAlert, LuX } from "react-icons/lu";
import SuccessCheckmark from "components/SuccessCheckmark/SuccessCheckmark";
import { feedbackBus } from "./InlineFeedback";
import "./draftSaveConfirmation.css";

export function showDraftSavedMessage(
  message = "Draft saved successfully",
  type = "success",
  title
) {
  feedbackBus.emit({
    scope: "draft-save",
    type,
    message,
    title,
    timestamp: Date.now(),
  });
}

export default function DraftSaveConfirmation() {
  const [confirmation, setConfirmation] = useState(null);
  const [visible, setVisible] = useState(false);
  const reducedMotion = useMediaQuery("(prefers-reduced-motion: reduce)");

  useEffect(
    () =>
      feedbackBus.subscribe((event) => {
        if (event.scope === "draft-save") {
          setConfirmation(event);
          setVisible(true);
        }
      }),
    []
  );

  useEffect(() => {
    if (!confirmation || confirmation.type === "warning") return undefined;
    const timer = setTimeout(() => setVisible(false), 4000);
    return () => clearTimeout(timer);
  }, [confirmation]);

  if (!confirmation) return null;

  const warning = confirmation.type === "warning";
  const error = confirmation.type === "error";
  const close = () => setVisible(false);

  return (
    <Dialog
      open={visible}
      onClose={close}
      maxWidth={false}
      className="editor-save-confirmation"
      aria-labelledby="editor-save-confirmation-title"
      aria-describedby="editor-save-confirmation-message"
      TransitionComponent={Fade}
      transitionDuration={reducedMotion ? 0 : { enter: 180, exit: 240 }}
      TransitionProps={{
        onExited: () => {
          if (!visible) setConfirmation(null);
        },
      }}
      BackdropProps={{ className: "editor-save-confirmation-backdrop" }}
      PaperProps={{ className: "editor-save-confirmation-paper" }}
    >
      <header className="editor-save-confirmation-header">
        <h2 id="editor-save-confirmation-title">
          {confirmation.title ||
            (warning ? "Please review" : error ? "Action failed" : "Success")}
        </h2>
        <button
          type="button"
          aria-label="Dismiss message"
          onClick={close}
          autoFocus
        >
          <LuX aria-hidden="true" />
        </button>
      </header>
      <DialogContent className="editor-save-confirmation-content">
        {warning || error ? (
          <span className="editor-save-confirmation-warning">
            <LuTriangleAlert aria-hidden="true" />
          </span>
        ) : (
          <SuccessCheckmark
            key={confirmation.timestamp}
            animate={!reducedMotion}
          />
        )}
        <p id="editor-save-confirmation-message">{confirmation.message}</p>
      </DialogContent>
    </Dialog>
  );
}
